"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
var _HeaderRequest = _interopRequireDefault(require("./HeaderRequest"));
var _RequestHeader = _interopRequireDefault(require("./RequestHeader"));
var _WarenkorbPos = _interopRequireDefault(require("./WarenkorbPos"));
var _Warenkorbdetails = _interopRequireDefault(require("./Warenkorbdetails"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * Rage+ API
 * API für das Rage+ / VerseNeo Backend der BLB Shops für Edelmetalle und Sorten
 *
 * The version of the OpenAPI document: 1.0.44
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */
/**
 * The EdelmetallWarenkorb model module.
 * @module model/EdelmetallWarenkorb
 * @version 1.0.44
 */
var EdelmetallWarenkorb = /*#__PURE__*/function () {
  /**
   * Constructs a new <code>EdelmetallWarenkorb</code>.
   * Warenkorb mit Edelmetallen
   * @alias module:model/EdelmetallWarenkorb
   * @implements module:model/HeaderRequest
   * @param header {module:model/RequestHeader} 
   * @param edelmetallWarenkorb {module:model/Warenkorbdetails} 
   * @param edelmetallWarenkorbPos {Array.<module:model/WarenkorbPos>} Positionen im Warenkorb
   */
  function EdelmetallWarenkorb(header, edelmetallWarenkorb, edelmetallWarenkorbPos) {
    _classCallCheck(this, EdelmetallWarenkorb);
    _HeaderRequest.default.initialize(this, header);
    EdelmetallWarenkorb.initialize(this, header, edelmetallWarenkorb, edelmetallWarenkorbPos);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  return _createClass(EdelmetallWarenkorb, null, [{
    key: "initialize",
    value: function initialize(obj, header, edelmetallWarenkorb, edelmetallWarenkorbPos) {
      obj['header'] = header;
      obj['edelmetallWarenkorb'] = edelmetallWarenkorb;
      obj['edelmetallWarenkorbPos'] = edelmetallWarenkorbPos;
    }

    /**
     * Constructs a <code>EdelmetallWarenkorb</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/EdelmetallWarenkorb} obj Optional instance to populate.
     * @return {module:model/EdelmetallWarenkorb} The populated <code>EdelmetallWarenkorb</code> instance.
     */
  }, {
    key: "constructFromObject",
    value: function constructFromObject(data, obj) {
      if (data) {
        obj = obj || new EdelmetallWarenkorb();
        _HeaderRequest.default.constructFromObject(data, obj);
        if (data.hasOwnProperty('header')) {
          obj['header'] = _RequestHeader.default.constructFromObject(data['header']);
        }
        if (data.hasOwnProperty('edelmetallWarenkorb')) {
          obj['edelmetallWarenkorb'] = _Warenkorbdetails.default.constructFromObject(data['edelmetallWarenkorb']);
        }
        if (data.hasOwnProperty('edelmetallWarenkorbPos')) {
          obj['edelmetallWarenkorbPos'] = _ApiClient.default.convertToType(data['edelmetallWarenkorbPos'], [_WarenkorbPos.default]);
        }
        if (data.hasOwnProperty('isMaKond')) {
          obj['isMaKond'] = _ApiClient.default.convertToType(data['isMaKond'], 'Boolean');
        }
      }
      return obj;
    }

    /**
     * Validates the JSON data with respect to <code>EdelmetallWarenkorb</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>EdelmetallWarenkorb</code>.
     */
  }, {
    key: "validateJSON",
    value: function validateJSON(data) {
      // check to make sure all required properties are present in the JSON string
      var _iterator = _createForOfIteratorHelper(EdelmetallWarenkorb.RequiredProperties),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var property = _step.value;
          if (!data[property]) {
            throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
          }
        }
        // validate the optional field `header`
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      if (data['header']) {
        // data not null
        _RequestHeader.default.validateJSON(data['header']);
      }
      // validate the optional field `edelmetallWarenkorb`
      if (data['edelmetallWarenkorb']) {
        // data not null
        _Warenkorbdetails.default.validateJSON(data['edelmetallWarenkorb']);
      }
      if (data['edelmetallWarenkorbPos']) {
        // data not null
        // ensure the json data is an array
        if (!Array.isArray(data['edelmetallWarenkorbPos'])) {
          throw new Error("Expected the field `edelmetallWarenkorbPos` to be an array in the JSON data but got " + data['edelmetallWarenkorbPos']);
        }
        // validate the optional field `edelmetallWarenkorbPos` (array)
        var _iterator2 = _createForOfIteratorHelper(data['edelmetallWarenkorbPos']),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var item = _step2.value;
            _WarenkorbPos.default.validateJSON(item);
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
        ;
      }
      return true;
    }
  }]);
}();
EdelmetallWarenkorb.RequiredProperties = ["header", "edelmetallWarenkorb", "edelmetallWarenkorbPos"];

/**
 * @member {module:model/RequestHeader} header
 */
EdelmetallWarenkorb.prototype['header'] = undefined;

/**
 * @member {module:model/Warenkorbdetails} edelmetallWarenkorb
 */
EdelmetallWarenkorb.prototype['edelmetallWarenkorb'] = undefined;

/**
 * Positionen im Warenkorb
 * @member {Array.<module:model/WarenkorbPos>} edelmetallWarenkorbPos
 */
EdelmetallWarenkorb.prototype['edelmetallWarenkorbPos'] = undefined;

/**
 * Gibt an, ob die Mitarbeiterkonditionen geholt werden sollen
 * @member {Boolean} isMaKond
 */
EdelmetallWarenkorb.prototype['isMaKond'] = undefined;

// Implement HeaderRequest interface:
/**
 * @member {module:model/RequestHeader} header
 */
_HeaderRequest.default.prototype['header'] = undefined;
var _default = exports.default = EdelmetallWarenkorb;